import { effect, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const publicOnlyGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isInitializing()) {
    return new Promise((resolve) => {
      const waitEffect = effect(() => {
        if (!authService.isInitializing()) {
          waitEffect.destroy();
          // redirect to home if authenticated
          resolve(!authService.isAuthenticated() ? true : router.createUrlTree(['/home']));
        }
      });
    });
  }
  // redirect to home if authenticated
  return !authService.isAuthenticated() ? true : router.createUrlTree(['/home']);
};
